export const SEND_OTP_FOR_FORGOT_PASSWORD = "SEND_OTP_FOR_FORGOT_PASSWORD"
export const SEND_OTP_FOR_FORGOT_PASSWORD_FAIL = "SEND_OTP_FOR_FORGOT_PASSWORD_FAIL"
export const SEND_OTP_FOR_FORGOT_PASSWORD_SUCCESS = "SEND_OTP_FOR_FORGOT_PASSWORD_SUCCESS"
export const SEND_OTP_FOR_FORGOT_PASSWORD_RESET = "SEND_OTP_FOR_FORGOT_PASSWORD_RESET"

export const sendOtpForForgotPassword = (params) => {
    return { type: SEND_OTP_FOR_FORGOT_PASSWORD, params }
}

export const sendOtpForForgotPasswordSuccess = (response) => {
    return { type: SEND_OTP_FOR_FORGOT_PASSWORD_SUCCESS, response }
}

export const sendOtpForForgotPasswordFail = (response) => {
    return { type: SEND_OTP_FOR_FORGOT_PASSWORD_FAIL, response }
}

export const sendOtpForForgotPasswordResetState = () => {
    return { type: SEND_OTP_FOR_FORGOT_PASSWORD_RESET }
}